import { DataKey, StatisticBase } from 'types'

export const getKeyBase = <T extends StatisticBase, K extends keyof T>(
  data: T,
  dataKey: DataKey<T, K>,
) => (typeof dataKey === 'function' ? dataKey(data) : data[dataKey]) as string
